import { browserHistory } from '@hotjar/webapp/utils/routing/browser-history';
import { OVERVIEW } from '@hotjar/webapp/constants/routes';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { STEPS } from '@hotjar/webapp/features/Activation/SetupWizard/steps';
import type { Site } from '@hotjar/site';

export const navigateToInstaller = (site: Site): void => {
  const url = `${getRoute(OVERVIEW.SETUP.path, { siteId: site.id })}?step=${
    STEPS.INSTALLATION_METHOD
  }`;
  const nextUrl = `${window.location.pathname}${window.location.search}`;

  browserHistory.push(`${url}&next=${encodeURIComponent(nextUrl)}`);
};
